import { Policy } from "@/interfaces/roles";
import { RootState } from "@/vuex/types";
import { GetterTree } from "vuex";
import PermissionState from "./permission.types";

type PermissionGetter = GetterTree<PermissionState, RootState>;
export const getters: PermissionGetter = {
  policies(state): Policy[] {
    return state.policies;
  },
  loading(state): boolean {
    return state.loading;
  }
};

export default getters;
